import {styled} from "@mui/material";
import {HoverElevationButton} from "./base-buttons";

export const MonthlyLimitsRemoveButton = styled(HoverElevationButton)(({theme}) => ({
    backgroundColor: theme.barekam.monthlyLimits.buttons.remove.backgroundColor,
    color: theme.barekam.monthlyLimits.buttons.remove.color,

    padding: '18px 24px 18px 18px',
    height: '60px',
    width: '220px',

    borderRadius: '0px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',

    '&:hover': {
        backgroundColor: theme.barekam.monthlyLimits.buttons.remove.backgroundColor,
    }
}));

export const MonthlyLimitsSetButton = styled(HoverElevationButton)(({theme}) => ({
    backgroundColor: theme.barekam.monthlyLimits.buttons.set.backgroundColor,
    color: theme.barekam.monthlyLimits.buttons.set.color,

    padding: '18px 24px 18px 18px',
    height: '60px',
    width: '220px',

    borderRadius: '0px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',

    '&:hover': {
        backgroundColor: theme.barekam.monthlyLimits.buttons.set.backgroundColor,
    }
}));